import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Transactions from "@/pages/Transactions";
import BankAccounts from "@/pages/BankAccounts";
import Contacts from "@/pages/Contacts";
import Upcoming from "@/pages/Upcoming";
import Reports from "@/pages/Reports";
import Categories from "@/pages/Categories";
import ImportPage from "@/pages/Import";
import { Toaster } from "@/components/ui/sonner";
import { Loader2 } from "lucide-react";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0B0F19]" data-testid="auth-loading">
        <Loader2 className="w-6 h-6 animate-spin text-indigo-400"/>
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login/>} />
          <Route path="/" element={<Protected><Dashboard/></Protected>} />
          <Route path="/transactions" element={<Protected><Transactions/></Protected>} />
          <Route path="/bank-accounts" element={<Protected><BankAccounts/></Protected>} />
          <Route path="/contacts" element={<Protected><Contacts/></Protected>} />
          <Route path="/upcoming" element={<Protected><Upcoming/></Protected>} />
          <Route path="/reports" element={<Protected><Reports/></Protected>} />
          <Route path="/categories" element={<Protected><Categories/></Protected>} />
          <Route path="/import" element={<Protected><ImportPage/></Protected>} />
          <Route path="*" element={<Navigate to="/" replace/>}/>
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
